module.exports = __webpack_public_path__ + "img/apple.98700697.png";